import type { Shop } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/node'

import type {
  ShopPromotionXPercentOffSchema,
  ShopPromotions,
} from '~/schemas/shop'

export function getEntireStoreDiscount(
  shop: Shop | SerializeFrom<Shop>
): number | undefined {
  return (
    (shop.promotions as ShopPromotions)?.find(
      (promo) =>
        promo.type == 'xPercentOff' &&
        (promo.minSpend == null || promo.minSpend == 0)
    ) as ShopPromotionXPercentOffSchema
  )?.amount
}

export function getSpendXPercentage(
  shop: Shop | SerializeFrom<Shop>
): number | undefined {
  return (
    (shop.promotions as ShopPromotions)?.find(
      (promo) =>
        promo.type == 'xPercentOff' &&
        promo.minSpend != null &&
        promo.minSpend != 0
    ) as ShopPromotionXPercentOffSchema
  )?.amount
}

export function getSpendXMinSpend(
  shop: Shop | SerializeFrom<Shop>
): number | undefined {
  return (
    (shop.promotions as ShopPromotions)?.find(
      (promo) =>
        promo.type == 'xPercentOff' &&
        promo.minSpend != null &&
        promo.minSpend != 0
    ) as ShopPromotionXPercentOffSchema
  )?.minSpend
}
